var FulfillmentType;
(function (FulfillmentType) {
    FulfillmentType["delivery"] = "delivery";
    FulfillmentType["pickup"] = "pickup";
})(FulfillmentType || (FulfillmentType = {}));

export { FulfillmentType };
//# sourceMappingURL=fulfillment_type.enum.js.map
